import React from "react";
import { Route, Routes } from "react-router-dom";

import { PROTECTED_ROUTES } from "./site-map";

import DashboardLayout from "../../components/layouts/dashboard-layout";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        {PROTECTED_ROUTES.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.component}
            exact={route.exact}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default AppRoutes;
